// extracted by mini-css-extract-plugin
export default {"page":"gR","wrapper":"hR","text":"iR","icons":"jR","icon":"kR","icon_text":"lR","carousel_wrapper":"mR","slide":"nR","image":"oR","arrows":"pR","prev":"qR","modal_root":"rR","x_mark":"sR","modal":"tR","images":"uR","main_image":"vR","name":"wR"};
    if(module.hot) {
      // 1743628927927
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  